{
	"noCategory": "Without category",
	"save": "Save changes",
	"add": "Add product",
	"edit": "Edit product",
	"equivalentProduct": "Equivalent product",
	"searchProduct": "Search by products",
	"name": "Name",
	"namePlaceholder": "Product's name",
	"category": "Category",
	"categoryPlaceholder": "Product category",
	"productPrice": "Product value",
	"description": "Description",
	"descriptionPlaceholder": "Product description",
	"mountableProduct": "Mountable product",
	"zigCategory": "Zig category",
	"sku": "SKU",
	"validadeField": "Required field",
	"product": "Product",
	"maxCount": "Qty maximum selectable",
	"price": "Value",
	"addItem": "Add item",
	"title": "Title",
	"titlePlaceholder": "Step title",
	"pricing": "Pricing",
	"sum": "Sum",
	"average": "Average",
	"higher": "Higher",
	"min": "Min",
	"max": "Max",
	"addItemName": "Item {{length}}",
	"step": "STEP {{index}}"
}
